import { useState } from "react";
import { authAPI } from "../api/client";
import { Link, useNavigate } from "react-router-dom";
import { trackLogin } from "../utils/analytics";
import "./OTP.css";

export default function OTP({ onVerified }) {
  const [otp, setOtp] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const verify = async (event) => {
    if (event) event.preventDefault();
    if (isVerifying || otp.length !== 6) return;
    try {
      setIsVerifying(true);
      setErrorMessage("");
      const userId = localStorage.getItem("pendingUserId");

      if (!userId) {
        setErrorMessage("Session expired. Please log in again.");
        navigate("/");
        return;
      }

      const res = await authAPI.verifyOTP(userId, otp);

      localStorage.setItem("token", res.data.token);
      if (res.data.refreshToken) localStorage.setItem("refreshToken", res.data.refreshToken);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      localStorage.removeItem("pendingUserId");
      sessionStorage.removeItem("hrportal_last_path");
      try {
        localStorage.removeItem("hrportal_user_access_v3");
        localStorage.removeItem("hrportal_user_access_v2");
        localStorage.removeItem("hrportal_user_access");
      } catch {
        // ignore storage errors
      }
      window.dispatchEvent(new Event("hrportal-auth"));
      trackLogin("otp");

      if (onVerified) onVerified();
      // Common landing page for every authenticated user. Role-based
      // dashboards remain reachable from Home, the sidebar and direct URLs.
      navigate("/home", { replace: true });
    } catch (err) {
      console.error("OTP verification failed", err);
      setErrorMessage(err.response?.data?.message || "OTP verification failed. Please try again.");
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <div className="otp-page">
      <div className="otp-content">

        <div className="otp-logo-section">
          <img loading="lazy"
            src={require("../assest/logo.png")}
            alt="Univision Logo"
            className="otp-logo-img"
          />
        </div>

        <div className="otp-card">
          <h3 className="otp-title">Enter Authenticator Code</h3>
          <form onSubmit={verify} noValidate>
            <label className="otp-label" htmlFor="otp-code">
              Authentication code
            </label>
            <input
              id="otp-code"
              className="otp-input"
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              autoComplete="one-time-code"
              autoFocus
              maxLength="6"
              value={otp}
              onChange={(e) => {
                setOtp(e.target.value.replace(/\D/g, "").slice(0, 6));
                if (errorMessage) setErrorMessage("");
              }}
              placeholder="000000"
              aria-invalid={errorMessage ? "true" : undefined}
              aria-describedby={errorMessage ? "otp-error" : undefined}
              disabled={isVerifying}
            />
            {errorMessage ? (
              <p id="otp-error" className="otp-error" role="alert">
                {errorMessage}
              </p>
            ) : null}
            <button
              type="submit"
              className="otp-submit-btn"
              disabled={isVerifying || otp.length !== 6}
            >
              {isVerifying ? "Verifying..." : "Verify"}
            </button>
          </form>
          <Link className="otp-back-link" to="/">
            Back to login
          </Link>
        </div>

      </div>
    </div>
  );
}
